module.exports = __webpack_public_path__ + "img/136ne.23d46b51.svg";